import { AccountServiceBase } from "../../config";
import { checkResponseErrors, makeRequestInit } from '../fetchHelper';
import { AccountData } from './AccountData';
import type { Authentication } from "../auth/Authentication";
import type { IAccountData } from "./server/model/IAccountData";

export class AccountsEndpoints {
    private _auth: Authentication;
    
    constructor(auth: Authentication) {
        this._auth = auth;
    }

    _dofetch(url: string, init: RequestInit) {
        return this._auth
            .fetch(AccountServiceBase + url, init)
            .then(checkResponseErrors);
    }

    getAccounts() {
        const init = makeRequestInit('GET');
        return this._dofetch('/accounts', init)
            .then(rsp => rsp.json())
            .then(json => json.map((x: IAccountData) => new AccountData(x)));
    }

    getAccount(id: string) {
        const init = makeRequestInit('GET');
        return this._dofetch('/accounts/' + id, init)
            .then(rsp => rsp.json())
            .then(json => new AccountData(json));
    }

    addAccount(account: AccountData) {
        const init = makeRequestInit('POST', account, true);
        return this._dofetch('/accounts', init)
            .then(() => void (0));
    }

    updateAccount(account: AccountData) {
        const init = makeRequestInit('PUT', account, true);
        return this._dofetch('/accounts/' + account.Id, init)
            .then(() => void (0));
    }

    archiveAccount(account: AccountData) {
        const init = makeRequestInit('POST', { Id: account.Id, ConcurrencyStamp: account.ConcurrencyStamp });
        return this._dofetch(`/accounts/${account.Id}/archive`, init)
            .then(() => void (0));
    }

    activateAccount(account: AccountData) {
        const init = makeRequestInit('POST', { Id: account.Id, ConcurrencyStamp: account.ConcurrencyStamp });
        return this._dofetch(`/accounts/${account.Id}/activate`, init)
            .then(() => void (0));
    }

    deleteAccount(account: AccountData) {
        const init = makeRequestInit('POST', { Id: account.Id, ConcurrencyStamp: account.ConcurrencyStamp });
        return this._dofetch(`/accounts/${account.Id}/delete`, init)
            .then(() => void (0));
    }

    resetAccount(account: AccountData) {
        const init = makeRequestInit('POST', { Id: account.Id, ConcurrencyStamp: account.ConcurrencyStamp });
        return this._dofetch(`/accounts/${account.Id}/reset`, init)
            .then(() => void (0));
    }
}
